type AllocationWarningConfig = {
  criticalDailyAmplitudeHours: number | null;
  criticalDailyVolumeHours: number | null;
  criticalRestPeriodHours: number | null;
};

const allocationWarningConfig: AllocationWarningConfig = {
  criticalDailyAmplitudeHours: null,
  criticalDailyVolumeHours: null,
  criticalRestPeriodHours: null,
};

export type { AllocationWarningConfig };
export { allocationWarningConfig };
